
{
  "familyId": "GET-BREUK-UITBREIDEN",
  "questions": [
    {
      "id": "GET-BREUK-UITBREIDEN-001",
      "familyId": "GET-BREUK-UITBREIDEN",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_uitbreiden",
      "questionType": "multiple_choice",
      "question": "Breid de breuk ²⁄₃ uit met noemer 12. Wat wordt de teller?",
      "options": [
        "8",
        "6",
        "4",
        "9"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "breuk_uitbreiden_basis",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Strategie: vermenigvuldig teller en noemer met hetzelfde getal. Stap 1: De noemer moet van 3 naar 12. Stap 2: 12 ÷ 3 = 4, dus vermenigvuldig met 4. Stap 3: Teller: 2 × 4 = 8. Stap 4: ²⁄₃ = ⁸⁄₁₂. Controleer: 8 ÷ 12 = 0,666... = 2 ÷ 3 ✓.",
        "distractorExplanations": {
          "0": "Goed! ²⁄₃ = ⁸⁄₁₂. De noemer × 4, dus de teller ook × 4: 2 × 4 = 8.",
          "1": "Veelgemaakte fout: alleen de noemer vermenigvuldigen. ⁶⁄₁₂ = ½, niet ²⁄₃. Je moet teller EN noemer met hetzelfde getal vermenigvuldigen.",
          "2": "Veelgemaakte fout: de noemer optellen bij de teller. 2 + 2 = 4, maar dat is niet hoe uitbreiden werkt. Je moet vermenigvuldigen: 2 × 4 = 8.",
          "3": "Veelgemaakte fout: de noemer bij de teller optellen. ⁹⁄₁₂ = ¾, niet ²⁄₃. Bij uitbreiden vermenigvuldig je, je telt niet op."
        }
      }
    },
    {
      "id": "GET-BREUK-UITBREIDEN-002",
      "familyId": "GET-BREUK-UITBREIDEN",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_uitbreiden",
      "questionType": "multiple_choice",
      "question": "Welke breuk is gelijk aan ¾ maar heeft noemer 20?",
      "options": [
        "¹⁵⁄₂₀",
        "¹²⁄₂₀",
        "⁸⁄₂₀",
        "¹⁶⁄₂₀"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "breuk_uitbreiden_kwarten",
      "variantIndex": 2,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Strategie: zoek de vermenigvuldigingsfactor. Stap 1: Noemer: 4 → 20. Factor: 20 ÷ 4 = 5. Stap 2: Teller: 3 × 5 = 15. Stap 3: ¾ = ¹⁵⁄₂₀. Controleer: 15 ÷ 20 = 0,75 = 3 ÷ 4 ✓.",
        "distractorExplanations": {
          "0": "Goed! ¾ = ¹⁵⁄₂₀. Factor = 5, dus 3 × 5 = 15.",
          "1": "¹²⁄₂₀ = ³⁄₅, niet ¾. Je hebt waarschijnlijk met 4 vermenigvuldigd in plaats van 5. 20 ÷ 4 = 5, niet 4.",
          "2": "⁸⁄₂₀ = ²⁄₅, niet ¾. De factor is 5 (20 ÷ 4), dus de teller wordt 3 × 5 = 15, niet 8.",
          "3": "¹⁶⁄₂₀ = ⁴⁄₅, niet ¾. Je hebt waarschijnlijk 4 × 4 = 16 gerekend, maar de teller is 3, niet 4."
        }
      }
    },
    {
      "id": "GET-BREUK-UITBREIDEN-003",
      "familyId": "GET-BREUK-UITBREIDEN",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_uitbreiden",
      "questionType": "multiple_choice",
      "question": "Je wilt ⅗ en ½ gelijknamig maken. Welke noemer gebruik je?",
      "options": [
        "10",
        "7",
        "15",
        "5"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "breuk_uitbreiden_gelijknamig",
      "variantIndex": 3,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Strategie: zoek het kleinste gemene veelvoud (KGV) van de noemers. Stap 1: De noemers zijn 5 en 2. Stap 2: Veelvouden van 5: 5, 10, 15, 20... Stap 3: Veelvouden van 2: 2, 4, 6, 8, 10... Stap 4: Het KGV = 10. Stap 5: ⅗ = ⁶⁄₁₀ en ½ = ⁵⁄₁₀.",
        "distractorExplanations": {
          "0": "Goed! KGV(5, 2) = 10. Beide breuken kunnen uitgebreid worden naar noemer 10: ⅗ = ⁶⁄₁₀ en ½ = ⁵⁄₁₀.",
          "1": "Veelgemaakte fout: de noemers optellen. 5 + 2 = 7, maar 7 is geen veelvoud van 5 of 2. Je kunt ⅗ niet uitbreiden naar noemer 7.",
          "2": "15 is een veelvoud van 5 (3 × 5), maar niet van 2. Je kunt ½ niet uitbreiden naar noemer 15 (15 is oneven). 10 is het kleinste getal dat door beide deelbaar is.",
          "3": "5 is al de noemer van ⅗, maar ½ kun je niet uitbreiden naar noemer 5 (5 is niet deelbaar door 2). Je hebt een noemer nodig die door beide deelbaar is."
        }
      }
    },
    {
      "id": "GET-BREUK-UITBREIDEN-004",
      "familyId": "GET-BREUK-UITBREIDEN",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_uitbreiden",
      "questionType": "multiple_choice",
      "question": "Breid ⅙ uit zodat de noemer 18 wordt. Wat is de nieuwe breuk?",
      "options": [
        "³⁄₁₈",
        "²⁄₁₈",
        "⁶⁄₁₈",
        "¹⁄₁₈"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "breuk_uitbreiden_zesden",
      "variantIndex": 4,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Strategie: vermenigvuldig teller en noemer met dezelfde factor. Stap 1: Noemer: 6 → 18. Factor: 18 ÷ 6 = 3. Stap 2: Teller: 1 × 3 = 3. Stap 3: ⅙ = ³⁄₁₈.",
        "distractorExplanations": {
          "0": "Goed! ⅙ = ³⁄₁₈. Factor = 3, dus 1 × 3 = 3.",
          "1": "²⁄₁₈ = ¹⁄₉, niet ⅙. De factor is 3 (18 ÷ 6 = 3), niet 2.",
          "2": "⁶⁄₁₈ = ⅓, niet ⅙. Je hebt de noemer als teller gebruikt. De teller is 1, niet 6: 1 × 3 = 3.",
          "3": "¹⁄₁₈ is niet gelijk aan ⅙. Bij uitbreiden moet je de teller ook vermenigvuldigen: 1 × 3 = 3, niet 1."
        }
      }
    },
    {
      "id": "GET-BREUK-UITBREIDEN-005",
      "familyId": "GET-BREUK-UITBREIDEN",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_uitbreiden",
      "questionType": "multiple_choice",
      "question": "Welke bewerking gebruik je bij het uitbreiden van een breuk?",
      "options": [
        "teller en noemer vermenigvuldigen met hetzelfde getal",
        "teller en noemer optellen met hetzelfde getal",
        "alleen de noemer vermenigvuldigen",
        "teller en noemer door hetzelfde getal delen"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "breuk_uitbreiden_begrip",
      "variantIndex": 5,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Strategie: onthoud de regel voor uitbreiden. Bij uitbreiden vermenigvuldig je teller EN noemer met hetzelfde getal. De waarde van de breuk verandert niet. Voorbeeld: ½ × ³⁄₃ = ³⁄₆. De breuk ziet er anders uit, maar is even groot.",
        "distractorExplanations": {
          "0": "Goed! Bij uitbreiden vermenigvuldig je teller en noemer met hetzelfde getal. Zo blijft de waarde gelijk.",
          "1": "Veelgemaakte fout: optellen in plaats van vermenigvuldigen. Als je bij ½ teller en noemer met 2 optelt, krijg je ³⁄₄ — dat is een andere waarde! Bij vermenigvuldigen: ²⁄₄ = ½ ✓.",
          "2": "Veelgemaakte fout: alleen de noemer aanpassen. Als je alleen de noemer vermenigvuldigt, verandert de waarde van de breuk. Je moet BEIDE aanpassen.",
          "3": "Delen is vereenvoudigen, niet uitbreiden. Bij uitbreiden maak je de noemer groter (vermenigvuldigen), bij vereenvoudigen maak je de noemer kleiner (delen)."
        }
      }
    }
  ]
}
